module.exports = __webpack_public_path__ + "media/AdobeStock_1.8347a049.mp4";